// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hashtag-card-enter-active[data-v-283f263e],.hashtag-card-leave-active[data-v-283f263e]{transition:opacity .2s ease,transform .2s ease}.hashtag-card-enter[data-v-283f263e],.hashtag-card-leave-to[data-v-283f263e]{opacity:0;transform:translateY(.5rem)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
